import React, { useState } from 'react';
import styles from "./GoTopButton.module.scss";
export function GoTopButton({ label }) {
    const [visible, setVisible] = useState(false);
    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 500) {
            setVisible(true);
        }
        else if (scrolled <= 500) {
            setVisible(false);
        }
    };
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    window.addEventListener('scroll', toggleVisible);
    return (React.createElement("div", { className: styles.container },
        React.createElement("button", { className: styles.button, onClick: scrollToTop, style: { display: visible ? 'inline' : 'none' } }, label)));
}
export default GoTopButton;
